import React from 'react';
import PropTypes from 'prop-types';
import QuantityInput from 'components/QuantityInput';

/**
 * This is quantity input component that needs to be used
 * as a component prop in redux-form.
 */
const QuantityInputField = props => {
  const {
    input,
    disableDecrement,
    disableIncrement,
    removeItemFromCart
  } = props;

  const val = input.value === '' ? 1 : parseInt(input.value);
  return (
    <QuantityInput
      label={'Qty:'}
      value={val === 0 ? '' : val}
      removeItemFromCart={removeItemFromCart}
      disableDecrement={disableDecrement}
      disableIncrement={disableIncrement}
      onChange={event => input.onChange(event.target.value)}
    />
  );
};

QuantityInputField.propTypes = {
  input: PropTypes.object,
  disableDecrement: PropTypes.bool,
  disableIncrement: PropTypes.bool,
  removeItemFromCart: PropTypes.func
};

export default QuantityInputField;
